import type { IInputOption } from "components/form/input/types";
import {
  getRefId,
  type ICompanyProfile,
  type ISavedDocument,
} from "findef";
import { UnlistedCompanyOption } from "@/modules/asset/views/add-asset/components/unlisted-company-option";
import { formatOrgNbr } from "@/utils/asset";

export const companyProfileToOption = (
  company: ISavedDocument<ICompanyProfile, string> | ICompanyProfile,
  listed: boolean = true,
): IInputOption => {
  return {
    value: company,
    label: company.symbol || company.companyName,
    key: getRefId(company) || (company as any)?.id,
    body: (props) => {
      const badgeText =
        listed !== true
          ? undefined
          : company?.isFund
            ? "Fund"
            : company?.isEtf
              ? "ETF"
              : "Stock";

      const exchange = company?.exchangeShortName || company?.exchange;

      return (
        <UnlistedCompanyOption
          name={company?.companyName}
          badge={badgeText}
          image={company?.manuallyAdded ? undefined : company?.image}
          imageSrc={company?.imageSource}
          orgNbr={
            !listed
              ? formatOrgNbr(company?.isin)
              : company?.manuallyAdded
                ? ""
                : company?.symbol +
                  (exchange
                    ? ` (${exchange} - ${company?.currency})`
                    : company?.currency
                      ? ` (${company.currency})`
                      : "")
          }
          isOpen={props.isOpen}
          listed={listed}
        />
      );
    },
  };
};
